import { CombinedGraphQLErrors } from '@apollo/client/core';

const errorHandler = (error: CombinedGraphQLErrors) => {
  return error.message || 'An Error Occured';
};

export const log = (string: any) => {
  process.stdout.write(`${string}\n`);
};

export default errorHandler;
